// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wmkIh","textarea":"styles_textarea__3Qbdx"};